import {Fragment, useRef} from 'preact/compat';
import {Dialog, Transition} from '@headlessui/react';
import {close} from '../../assets';
import s from './beneficiaryModal.module.css';
import BeneficiaryForm from './BeneficiaryForm';
import { useAppContext } from '../../contexts';

const BeneficiaryModal = props => {
    // Destructured props
    const {
        open,
        setOpen,
        beneficiary,
        enableForeigner,
        rehydrateBeneficiariesState,
        handleBeneficiary = () => {},
        handleCurrentBeneficiaryChange = () => {},
        stockItem = undefined,
        source = "default",
        nadOrder = undefined,
        productId = undefined
    } = props;

    // Title to be displayed at the top of the modal
    const title =
        Object.keys(beneficiary).length > 1 ?
            'Editar beneficiário' :
            'Novo beneficiário';

    // Ref for the cancel button
    const cancelButtonRef = useRef(null);

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-fade-modal bg-opacity-75 transition-opacity" />
                </Transition.Child>
                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-2 text-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className={`relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-8 w-full max-w-[40rem] p-6 ${highContrast ? "grayBackground" : "bg-light-gray"}`}>
                                <div>
                                    <div className="text-start">
                                        <div className={'flex justify-between'}>
                                            <Dialog.Title as="h3" className={`max-w-[20rem] text-[20px] font-semibold leading-6 text-gray-800 ${highContrast ? "highTitleFirst" : ""}`}>
                                                {title}
                                            </Dialog.Title>
                                            <button className={'flex w-5 select-none'} onClick={() => setOpen(false)}>
                                                <img src={close} alt="cancel" className={`w-full ${highContrast ? "grayscale" : ""}`} />
                                            </button>
                                        </div>
                                        <hr className={`${s.separator} ${highContrast ? "yellowBorder" : ""}`} />
                                        <div className="mt-2">
                                            <BeneficiaryForm
                                                beneficiary={beneficiary}
                                                setOpen={setOpen}
                                                rehydrateBeneficiariesState={rehydrateBeneficiariesState}
                                                handleBeneficiary={handleBeneficiary}
                                                stockItem={stockItem}
                                                handleCurrentBeneficiaryChange={handleCurrentBeneficiaryChange}
                                                enableForeigner={enableForeigner}
                                                source={source}
                                                nadOrder={nadOrder}
                                                productId={productId}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <p className={`text-xs mt-[0.5rem] ${highContrast ? "highTitleThird" : "text-[#666]"}`}>
                                    *Campos de preenchimento obrigatório.
                                </p>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default BeneficiaryModal;
